module.exports = __webpack_public_path__ + "static/media/dashboard_board.01fd524d.svg";